import React, { useEffect, useState, useMemo } from "react";
import s from "../Profile.module.css";
import { useAuth } from "../context/AuthContext";
import { useAppTranslation } from "./TranslationContext";
import { Link } from "react-router-dom";

// Компонент карточки курса
const CourseCard = ({ course, index }) => (
  <Link className={s.course_link} to={"/course/" + course.id}>
    <div className={s.profile__course}>
      <p className={s.profile__course__title}>{course.title}</p>
      <p className={s.profile__course__info}>{course.info}</p>
      <img
        src={course.img}
        alt=""
        className={s.profile__course__img}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/images/default.png";
        }}
      />
    </div>
  </Link>
);

export const Profile = () => {
  const [userData, setUserData] = useState([]);           
  const [loadingUser, setLoadingUser] = useState(true);
  const [errorUser, setErrorUser] = useState(null);

  const [allCourses, setAllCourses] = useState([]);
  const [myCourses, setMyCourses] = useState([]);
  const [recommendedCourses, setRecommendedCourses] = useState([]);

  const { user, handleLang } = useAuth();
  const { t } = useAppTranslation();

  // 1) Получаем user-kurs
  useEffect(() => {
    if (!user?.id) return;

    fetch(`https://api.rasulova-academy.uz/api/user-kurs/?user=${user.id}`)
      .then((response) => {
        if (!response.ok) throw new Error("Ошибка сети: " + response.status);
        return response.json();
      })
      .then((json) => {
        setUserData(json || []);
        setLoadingUser(false);
      })
      .catch((err) => {
        setErrorUser(err.message);
        setLoadingUser(false);
      });
  }, [user?.id]);

  // 2) Получаем ВСЕ курсы (один раз после того как знаем userData)
  useEffect(() => {
    // можно грузить и раньше, но так проще выстроить зависимости
    if (loadingUser) return;

    fetch("https://api.rasulova-academy.uz/api/kurslar/")
      .then(res => {
        if (!res.ok) throw new Error("Kurslarni olishda xatolik");
        return res.json();
      })
      .then(all => setAllCourses(Array.isArray(all) ? all : []))
      .catch(err => {
        console.error("Kurslar olish xatosi:", err);
        setAllCourses([]);
      });
  }, [loadingUser]);

  // 3) Разделяем на мои и рекомендованные (макс. 6), исключая мои
  useEffect(() => {
    const myIds = new Set(userData.map(k => k.kurs));
    const mine = allCourses.filter(c => myIds.has(c.id));
    const notMine = allCourses.filter(c => !myIds.has(c.id));

    // Перемешаем рекомендованные и возьмём максимум 6
    const shuffled = [...notMine].sort(() => Math.random() - 0.5).slice(0, 6);

    setMyCourses(mine);
    setRecommendedCourses(shuffled);
  }, [allCourses, userData]);

  if (loadingUser) return <div>Yuklanmoqda...</div>;
  if (errorUser) return <div>Xatolik: {errorUser}</div>;

  return (
    <section className={s.profile}>
      <div className={s.profile__hero}>
        <div className={s.profile__hero__text}>
          <p className={s.profile__title}>{t('hello')} {user.username}!</p>
          <p className={s.profile__subtitle}>{t('profileSub')}</p>
          <Link to="/more" className={s.moreBtn}>{t('profileCustom')}</Link>
        </div>
        <div className={s.profile__hero__img}>
          <img src="/images/userSite.png" alt="img" />
        </div>
      </div>

      {/* Мои курсы */}
      {/* Мои курсы (только если есть хотя бы один) */}
      {myCourses.length > 0 && (
      <div className={s.profile__mycourses}>
        <p className={s.profile__courses__title}>{t('myCourses')}</p>
        <div className={s.profile__mycourses__courses}>
          {myCourses.map((course, index) => (
            <CourseCard
              key={course.id}
              course={{
                id: course.id,
                title: handleLang(course.nomi_uz, course.nomi_ru, course.nomi_en),
                info: handleLang(course.description_uz, course.description_ru, course.description_en),
                img: course.img_uz
              }}
              index={index}
            />
          ))}
          {myCourses.length === 0 && (
            <p className={s.emptyText}>{t('noMyCourses') || 'Sizda hali kurslar yo‘q.'}</p>
          )}
        </div>
      </div>
      )}

      {/* Рекомендуемые курсы (макс. 6) */}
      <div className={s.profile__courses}>
        <p className={s.profile__courses__title}>{t('popCourses')}</p>
        <div className={s.profile__mycourses__courses}>
          {recommendedCourses.map((course, index) => (
            <CourseCard
              key={course.id}
              course={{
                id: course.id,
                title: handleLang(course.nomi_uz, course.nomi_ru, course.nomi_en),
                info: handleLang(course.description_uz, course.description_ru, course.description_en),
                img: course.img_uz
              }}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
